var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_705_1375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6765 5.80764H2.19188C1.66881 5.80764 1.14573 5.41533 1.14573 4.76149C1.14573 4.10764 1.66881 3.71533 2.19188 3.71533C9.8011 3.71533 14.0673 3.71533 21.6765 3.71533C22.3303 3.71533 22.7227 4.10764 22.7227 4.76149C22.7227 5.41533 22.1996 5.80764 21.6765 5.80764ZM10.1919 11.9538H21.6765C22.3303 11.9538 22.7227 12.3461 22.7227 12.9999C22.7227 13.6538 22.1996 14.0461 21.6765 14.0461H10.1919C9.66881 14.0461 9.14573 13.6538 9.14573 12.9999C9.14573 12.3461 9.66881 11.9538 10.1919 11.9538ZM2.19188 20.0615H21.6765C22.3303 20.0615 22.7227 20.4538 22.7227 21.1076C22.7227 21.7615 22.1996 22.1538 21.6765 22.1538H2.19188C1.66881 22.1538 1.14573 21.7615 1.14573 21.1076C1.14573 20.4538 1.66881 20.0615 2.19188 20.0615Z",
    fill: "#3921F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9L1 4.5L5.5 1",
    stroke: "#3921F5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_705_1375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.cba38a35b67496fd8d73302b7496b26a.svg";
export { ForwardRef as ReactComponent };